export default __webpack_public_path__ + "static/media/T.ee746a26.svg";